import { c as _c } from "react/compiler-runtime";
import type { ItineraryCardHeaderProps } from './ItineraryCard.types';
import styles from './ItineraryCardHeader.module.css';
export function ItineraryCardHeader(t0) {
  const $ = _c(10);
  const {
    icon,
    title,
    meta
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <span className={styles.icon} aria-hidden="true">{icon}</span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <span className={styles.title}>{title}</span>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== meta) {
    t3 = meta ? <span className={styles.meta}>{meta}</span> : null;
    $[4] = meta;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={styles.header}>{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}